<template>
  <div class="playlist" :style="{ 'overflow-y': viewDetail ? 'hidden' : 'auto' }">
    <MenuPlaylist
      v-if="viewDetail"
      :playlist="currentPlaylist"
      @back="back"
      @export="openConfirmExport"
      @change="onChange"
    />
    <ListPlaylist
      v-else
      :user-playlists="userPlaylists"
      @export="openConfirmExport"
      @select="onSelect"
      @back="$emit('back')"
    />
    <ExportVideo :showModalConfirm="showConfirmExport" @onCancelExport="onCancelExport" :infomodal="infomodal" />
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import EventBus from '@/utils/event-bus';

export default {
  name: 'MyPlaylist',
  components: {
    ExportVideo: () => import('@/components/Modals/ExportVideo'),
    MenuPlaylist: () => import('@/components/Sections/MediaPlayer-v2/modal-mode/MenuPlaylist'),
    ListPlaylist: () => import('@/components/Sections/MediaPlayer-v2/modal-mode/ListPlaylist'),
  },
  data() {
    return {
      viewDetail: false,
      currentPlaylist: {},
      showConfirmExport: false,
      infomodal: 0,
    };
  },
  computed: {
    ...mapState('mediaGeneral', ['userPlaylists']),
    ...mapState('mediaModal', ['modalSectionSelected']),
    ...mapState('loginGeneral', ['user']),
  },
  watch: {
    modalSectionSelected(newValue) {
      if (newValue !== 4) {
        this.setCurrentPlaylistPlays([]);
      }
    },
  },
  methods: {
    ...mapMutations('mediaModal', ['setCurrentPlaylistPlays']),
    onCancelExport() {
      this.showConfirmExport = false;
    },
    openConfirmExport(val) {
      val.user = this.user.id;
      this.infomodal = val;
      this.showConfirmExport = true;
    },
    onSelect(index) {
      this.onIndexChanged(index);
      this.viewDetail = true;
    },
    onIndexChanged(index) {
      EventBus.$emit('some-list-selected');
      this.currentPlaylistIndex = index;
      this.currentPlaylist = this.userPlaylists[index] || {};
      this.setCurrentPlaylistPlays(this.currentPlaylist.plays || []);
    },
    back() {
      this.viewDetail = false;
    },
    onChange(type) {
      let newIndex = 0;
      if (type === 'next') {
        newIndex = this.currentPlaylistIndex === this.userPlaylists.length - 1 ? 0 : this.currentPlaylistIndex + 1;
      } else {
        newIndex = this.currentPlaylistIndex === 0 ? this.userPlaylists.length - 1 : this.currentPlaylistIndex - 1;
      }
      this.onIndexChanged(newIndex);
    },
  },
};
</script>

<style scoped lang="scss">
.playlist {
  font-size: 1rem;
  width: 100%;
  height: 100%;
  max-height: 786px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 1em;
  border-radius: 13px;
  border: solid 2px #e4eef4;
  font-family: Avenir-Demi, sans-serif;
  overflow-x: auto;
}
</style>
